var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZendesk(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4301 62.1444V169.221H-0.259766L88.4301 62.1444Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4301 23.71C88.4301 35.471 83.7581 46.7503 75.4418 55.0666C67.1255 63.3829 55.8462 68.0549 44.0852 68.0549C32.3242 68.0549 21.0448 63.3829 12.7286 55.0666C4.41227 46.7503 -0.259766 35.471 -0.259766 23.71H88.4301Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.041 169.221C103.041 157.46 107.713 146.181 116.029 137.864C124.346 129.548 135.625 124.876 147.386 124.876C159.147 124.876 170.426 129.548 178.742 137.864C187.059 146.181 191.731 157.46 191.731 169.221H103.041Z",
    fill: "#03363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.041 130.787V23.71H191.74L103.041 130.787Z",
    fill: "#03363D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZendesk);
export default __webpack_public_path__ + "static/media/Zendesk.89205b30dd0509457d0b322fa4f40b99.svg";
export { ForwardRef as ReactComponent };